/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Provision_DefaultsInputs */

const cs_settings_office_provision_defaults = /** @type {(inputs: Settings_Office_Provision_DefaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výchozí % provize`)
};

const en_settings_office_provision_defaults = /** @type {(inputs: Settings_Office_Provision_DefaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default commission %`)
};

/**
* | output |
* | --- |
* | "Default commission %" |
*
* @param {Settings_Office_Provision_DefaultsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_provision_defaults = /** @type {((inputs?: Settings_Office_Provision_DefaultsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Provision_DefaultsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_provision_defaults(inputs)
	return cs_settings_office_provision_defaults(inputs)
});